

menu_options = nav_links = [
  {
    href: '/tour'
    label: 'How it works'
    short_label: 'Tour'
  }
  {
    href: '/examples'
    label: 'Examples'
  }  
  { 
    href: '/pricing'
    label: 'Pricing'
  }
  {
    href: '/contact'
    label: 'Contact'
  }
  {
    href: '/create_forum'
    label: 'Create a Forum'
    short_label: 'Create Forum'
  }
]


styles += """

  [data-widget="ProductHeader"] .nav_menu_item {
    font-weight: 400;
    transition: border 500ms, color 500ms;
  }

  [data-widget="ProductHeader"] .header_wrapper {
    width: var(--SAAS_PAGE_WIDTH);
    margin: auto;
    transition: border 500ms;
  }

  [data-widget="ProductHeader"] a.considerit_logo {
    display: inline-block;
    position: relative;
    top: 12px;
    height: 70px;
  }


  @media (max-width: 598px) {
    [data-widget="ProductHeader"] .header_wrapper {
      padding-bottom: 2px;
    }
    [data-widget="ProductHeader"] a.considerit_logo {
      height: 40px;
    }
    [data-widget="ProductHeader"] .nav_menu_container {
      bottom: -12px;
    }
  } 

  @media (min-width: 1065px) {

    [data-widget="ProductHeader"] .nav_menu_container {
      position: relative;
      bottom: 38px;
      display: block;
      float: right;
    }

    [data-widget="ProductHeader"] .nav_menu_item {
      padding: 14px 10px;
      border: 1px solid transparent;
      border-bottom: none;
      text-transform: uppercase;
      font-size: 18px;
      margin-left: 25px;
      text-decoration: none;

    }

    [data-widget="ProductHeader"] .nav_menu_item:last-child {
      padding: 14px 20px;
      border-radius: 8px 8px 0px 0;
    }

  }

  [data-widget="HamburgerMenu"] {
    display: none;
  }

  @media (max-width: 1064px) {
    [data-widget="ProductHeader"] .nav_menu_container {
      padding-top: 24px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 18px 28px;
    }

    [data-widget="ProductHeader"] .nav_menu_item {
      font-size: 22px;
    }
  }

  @media (max-width: 653px) {
    [data-widget="ProductHeader"] .nav_menu_item {
      font-size: 18px;
    }
  }

  @media (max-width: 550px) {
    [data-widget="ProductHeader"] .nav_menu_item {
      font-size: 16px;
    }
  }

  @media (max-width: 500px) {
    [data-widget="ProductHeader"] .nav_menu_container {
      gap: 18px 18px;      
    }
  }

  @media (max-width: 400px) {
    [data-widget="ProductHeader"] .nav_menu_item {
      font-size: 15px;
    }
  }

  @media (max-width: 374px) {
    [data-widget="ProductHeader"] .nav_menu_item {
      display: none;
    }

    [data-widget="HamburgerMenu"] {
      display: block;
    }

    [data-widget="ProductHeader"] .nav_menu_container {
      position: absolute;
      bottom: 0px;
      display: block;
      left: calc(100% - 72px);
      padding-top: 0;
    }
  }




"""

window.ProductHeader = ReactiveComponent
  displayName: "ProductHeader"
  render: ->
    current_user = bus_fetch("/current_user")
    loc = bus_fetch('location')

    @portrait_mobile = SAAS_PAGE_WIDTH() < 550

    @local.dot_x ?= 0
    dot_size = if @portrait_mobile then 6 else 10


    homepage = loc.url == '/'
    color = bus_fetch 'colors'

    main_color = if color.primary_color == 'white' then seattle_salmon else 'white'

    HEADER
      style:
        position: "relative"
        margin: "0 auto 5px auto"

      DIV
        className: 'header_wrapper'


        DIV 
          style:
            borderBottom: "1px solid #{main_color}"


          # logo
          A 
            className: 'considerit_logo'
            ref: 'logo'
            href: '/'

            drawLogo
              height: '100%'
              main_text_color: main_color
              o_text_color: 'transparent'
              box_shadow: true


            SVG 
              height: dot_size 
              viewBox: "0 0 #{dot_size} #{dot_size}" 
              version: "1.1" 
              xmlns: "http://www.w3.org/2000/svg" 
              style: 
                transition: 'left 500ms'
                position: 'absolute'
                left: @local.dot_x - dot_size / 2
                zIndex: 2
                bottom: 0 # -dot_size / 2


              G null,

                CIRCLE 
                  style: 
                    transition: 'fill 500ms'
                  fill: main_color
                  cx: dot_size / 2
                  cy: dot_size / 2
                  r: dot_size / 2
                 


        # nav menu
        DIV 
          className: 'nav_menu_container'

          HamburgerMenu {nav_links}

          for nav,idx in nav_links
            A 
              ref: nav.href
              key: idx
              className: "condensed nav_menu_item"
              style: 
                color: main_color
                borderColor: if idx == nav_links.length - 1 then main_color

              href: nav.href
              if WINDOW_WIDTH() < 464 && nav.short_label 
                nav.short_label 
              else 
                nav.label

  positionDot: -> 
    url = bus_fetch('location').url
    
    if url.indexOf('/examples') > -1
      url = '/examples'
      
    link = ReactDOM.findDOMNode(@refs[url])
    logo = ReactDOM.findDOMNode(@refs.logo).getBoundingClientRect()


    if link && WINDOW_WIDTH() > 374
      rect = link.getBoundingClientRect()
      dot_x = (rect.left - logo.left) + (rect.right - rect.left) / 2
    else  
      dot_x = (logo.right - logo.left) - (if @portrait_mobile then 21 else 38)

    if dot_x != @local.dot_x

      @local.dot_x = dot_x
      save @local 

  componentDidMount: -> @positionDot()
  componentDidUpdate: -> @positionDot()

HamburgerMenu = ReactiveComponent
  displayName: 'HamburgerMenu'

  render : -> 
    w = SAAS_PAGE_WIDTH()
    @portrait_mobile = w < 550

    set_focus = (idx) => 
      idx = 0 if !idx?
      @local.focus = idx 
      save @local 
      setTimeout => 
        ReactDOM.findDOMNode(@refs["menuitem-#{idx}"]).focus()
      , 0

    close_menu = => 
      document.activeElement.blur()
      @local.menu = false
      save @local


    homepage = false # bus_fetch('location').url == '/'
    main_color = if homepage then seattle_salmon else 'white'
    link_color = if homepage then seattle_salmon else primary_color()

    DIV
      key: 'hamburger'
      ref: 'menu_wrap'
      style:
        position: 'relative'

      onTouchEnd: => 
        @local.menu = !@local.menu
        save(@local)

      onMouseEnter: (e) => @local.menu = true; save(@local)
      onMouseLeave: close_menu

      onBlur: (e) => 
        setTimeout => 
          # if the focus isn't still on an element inside of this menu, 
          # then we should close the menu
          el = document.querySelector('[data-widget="HamburgerMenu"]')
          if el && !$$.closest(document.activeElement, '[data-widget="HamburgerMenu"]')
            @local.menu = false; save @local
        , 0

      onKeyDown: (e) => 
        if e.which == 13 || e.which == 32 || e.which == 27 # ENTER or ESC
          close_menu()
          e.preventDefault()
        else if e.which == 38 || e.which == 40 # UP / DOWN ARROW
          @local.focus = -1 if !@local.focus?
          if e.which == 38
            @local.focus--
            if @local.focus < 0 
              @local.focus = menu_options.length 
          else
            @local.focus++
            if @local.focus > menu_options.length 
              @local.focus = 0 
          set_focus(@local.focus)
          e.preventDefault() # prevent window from scrolling too

      BUTTON 
        tabIndex: 0
        'aria-haspopup': "true"
        'aria-owns': "hamburger_popup"
        "aria-label": "Open the navigation menu"


        style: 
          border: "1px solid #{main_color}"
          borderBottom: 'none'
          borderRadius: '8px 8px 0px 0'
          padding: '0px 6px'
          position: 'relative'
          backgroundColor: 'transparent'

        onKeyDown: (e) => 
          if e.which == 13 || e.which == 32
            @local.menu = true
            save(@local)
            if !@local.focus? 
              set_focus(0)
            e.preventDefault()
            e.stopPropagation()

        SVG 
          height: if @portrait_mobile then 32 else 44 
          viewBox: "0 0 32 24" 
          width: if @portrait_mobile then 32 else 44

          PATH 
            fill: main_color
            d: "M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"


      UL 
        id: 'hamburger_popup'
        role: "menu"
        'aria-hidden': !@local.menu
        hidden: !@local.menu
        style: 
          listStyle: 'none'
          position: 'absolute'
          left: 'auto'
          right: if !@local.menu then -9999 else 8
          margin: '-10px 0 0 -8px'
          padding: "16px 14px 8px 8px"
          backgroundColor: 'white'
          textAlign: 'right'
          zIndex: 999999
          boxShadow: '0 1px 2px rgba(0,0,0,.2)'


        for option, idx in menu_options
          LI 
            key: option.label
            role: "presentation"
            A
              ref: "menuitem-#{idx}"
              role: "menuitem"
              tabIndex: if @local.focus == idx then 0 else -1
              href: option.href
              key: option.href
              style: 
                color: if @local.focus == idx then link_color else '#303030'
                outline: 'none'
                position: 'relative'
                bottom: 8
                padding: '10px 0 10px 27px'
                display: 'block'
                whiteSpace: 'nowrap'
                fontSize: 30
                borderBottom: if idx != menu_options.length - 1 then '1px solid #eaeaea'
                textDecoration: 'none'

              onClick: (e) => 
                close_menu()

              onTouchEnd: (e) =>
                close_menu()

              onKeyDown: (e) => 
                if e.which == 13 || e.which == 32 # ENTER or SPACE
                  e.currentTarget.click()
                  e.preventDefault()
              onFocus: do(idx) => (e) => 
                if @local.focus != idx 
                  set_focus idx
                e.stopPropagation()
              onMouseEnter: do(idx) => => 
                if @local.focus != idx                         
                  set_focus idx

              onBlur: (e) => 
                @local.focus = null 
                save @local  

              onMouseLeave: (e) => 
                @local.focus = null 
                save @local
                e.stopPropagation()


              option.label



/** WEBPACK FOOTER **
 ** ../wwwconsiderit/@client/product_page/header.coffee
 **/